export default __webpack_public_path__ + "static/media/placement-test-icon.596ab9d8.png";